const colors = {
  // old mazda site:
  chineseBlack: "#161616",
  charlestonGrey: "#2b2b2b",
  arsenic: "#414141",
  philippineGray: "#808080",
  cssYellow: "yellow",
  //
  darkBlack: "#000000",
  white: "#fff",
  transparent: "rgba(247,243,235,0)",
  // mazda:
  headerColor: "#020202",

  black: "#101010",
  darkGrey: "#999999",
  mazdaRed: "#910A2D",
  borderGrey: "#D5D5D5",
  lightGrey: "#F5F5F5",
  gainsboro: "#dadada",
  onyx: "#566066",
  brightGray: "#eeeeee",
  saphire: "#4C607E",
  disable: "#616161",
  steel: "#3A3D46",
  platinum: "#E5E5E5",
  // from Lehamim:
  grey: "#f7f7f7",
  lightGray: "#E7E7E7",
  cherryRed: "#B11116",
  red: "#d70202",
  backgroundError: "#EDDBDB",
  coffeeBrown: "#45251C",
  paprika: "#A54C4C",
  wheat: "#DDD6C5",
  flour: "#F7F3EB",
  sand: "#BEB6A6",
  yellow: "#ffbc0d",
  darkYellow: "#ffb900",
  blackOlive: "#281813",
  bazil: "#61A864",
  lightBackground: "#FEFEFD",
  darkGreen: "#264f36",
  whiteGlassFill: "rgba(254, 254, 253, 0.8)",
  flourGlassFill: "rgba(247, 243, 235, 0.8)",
  memberRedGold:
    "linear-gradient(90deg, #FFDDD2 0%, #FFF3EF 16.15%, #FFDDD2 48.96%, #FFF3EF 77.08%, #FFDDD2 100%)",
  memberRedGoldSolid: "#FFDDD2",
  marbleGrey: "#857878",
  wheatOpacity: "rgba(221, 214, 197, 0.8)",
  flourOpacity: "rgba(247, 243, 235, 0.8)",
  neutral: "#6D6D6D",
  newPrimaryRed: "#a6192e",
  // Figma primitive (token-named): Primitives/Neutral/200 — section background
  neutral200: "#f5f3f1",
  // Figma primitive (token-named): Primitives/Neutral/300 — price divider, arrow surfaces
  neutral300: "#d0d0d0",
  // Figma primitive (token-named): Primitives/Neutral/400
  neutral400: "#9e9e9e",

  //custom
  notExistentCream: "#dadada",
  notExistentGray: "#B5B5B5",
  notExistentDarkGray: "#777777",
  notExistentSaphire: "#B4B9BD",
  nonExistentLightGray: "#d0d3da",
  nonExistentBlue: "#0089CF",
  nonExistentLightBlue: "#e4eef8",

  // homepage footer section
  footerLinkBright: "#f5f3f1",
  footerLinkMobile: "#999999",
  footerContactMobile: "#e7e7e7",

  // homepage newsletter section
  newsletterBg: "#f5f3f1",
  newsletterInputBorder: "#9e9e9e",
  newsletterBorderMobile: "#d0d0d0",
  newsletterLink: "#0099ff",
  successGreen: "#266c29",
  dangerRed: "#e01b22",
}

export default colors
